function calculateValue(criteria, data, invert) {
	let value = criteria.reduce(
		(acc, criterium) => {
			const value = ((data[criterium] === 'arrangement' ? 1 : 0) * 100) / criteria.length;

			return invert ? acc - value : acc + value;
		},
		invert ? 100 : 0
	);

	value = parseInt(value, 10);

	value = Math.max(0, value);
	value = Math.min(100, value);

	return value;
}

module.exports = {
	steps: [
		{
			title: {
				de: 'Plötzlich bin ich krank oder habe einen Unfall und bin nicht mehr urteilsfähig. Wer soll in diesem Fall für mich handeln und entscheiden?',
				fr: "Soudainement je suis malade ou victime d'un accident et je ne suis plus capable de discernement, qui doit agir et décider pour moi dans ce cas?"
			},
			name: 'incapacity',
			options: [
				{
					value: 'arrangement',
					label: {
						de: 'Ich bespreche meine Wünsche für die persönliche Betreuung, die Wohnsituation und die finanziellen Angelegenheiten mit meiner Familie und bestimme mit einem Vorsorgeauftrag Personen meines Vertrauens, die bei meiner Urteilsunfähigkeit in meinem Sinn entscheiden.',
						fr: "Je discute avec ma famille de mes souhaits en matière de soins personnels, de la situation du logement et des questions financières et, au moyen d'un mandat pour cause d'inaptitude, je désigne des personnes de confiance pour prendre des décisions en ma faveur en cas d'incapacité de jugement."
					}
				},
				{
					value: 'default',
					label: {
						de: 'Ohne Vorsorgeauftrag bestimmt die Kindes- und Erwachsenenschutzbehörde (KESB), wer als meine Vetrtetungspersonen eingesetzt werden.',
						fr: "Sans mandat pour cause d'inaptitude, l'Autorité de protection de l'enfant et de l'adulte (APEA) détermine qui seront mes représentants."
					}
				}
			],
			value: null
		},
		{
			title: {
				de: 'Ich habe einen Unfall und liege anschliessend im Koma. Ich kann nicht mehr selber entscheiden, was mit mir geschieht. Wer entscheidet, welche Behandlungen angewendet oder welche lebenserhaltenden Massnahmen eingeleitet werden?',
				fr: "J'ai un accident et je suis ensuite dans le coma. Je ne peux plus décider par moi-même de ce qui me concerne. Qui décide des traitements utilisés ou des mesures de maintien de la vie?"
			},
			name: 'advancedirective',
			options: [
				{
					value: 'arrangement',
					label: {
						de: 'Ich bestimme selbst mittels einer Patientenverfügung, was mit mir passiert. Damit sorge ich bei Ärzten für Klarheit und entlaste meine Angehörigen.',
						fr: "Je décide moi-même par le biais des directives anticipées ce qui m'arrive. De cette façon, je donne de la clarté aux médecins et je soulage mes proches."
					}
				},
				{
					value: 'default',
					label: {
						de: 'Ohne Patientenverfügung werden die im Gesetz festgelegten Ansprechpersonen als medizinische Vertretung herangezogen.',
						fr: 'Sans directives anticipées, les personnes de contact spécifiées dans la loi sont utilisées comme représentants médicaux.'
					}
				}
			],
			value: null
		},
		{
			title: {
				de: 'Nach einer Hirnblutung oder einem Unfall mit Schädel-Hirn-Verletzung sterbe ich im Spital. Wer entscheidet, ob eine Organspende in Frage kommt?',
				fr: "Après une hémorragie cérébrale ou un accident avec lésion craniocérébrale, je meurs à l'hôpital. Qui décide si le don d'organes est une option?"
			},
			name: 'organs',
			options: [
				{
					value: 'arrangement',
					label: {
						de: 'Ich halte meinen Entscheid fest, was mit meinen Organen und/oder meinem Gewebe passieren soll.',
						fr: "Je garde ma décision sur ce qu'il faut faire avec mes organes et/ou tissus."
					}
				},
				{
					value: 'default',
					label: {
						de: 'Meine Angehörigen sollen über die Entnahme von Organen entscheiden.',
						fr: 'Je veux que mes proches décident du prélèvement des organes.'
					}
				}
			],
			value: null
		},
		{
			title: {
				de: 'Ich sterbe und meine Angehörigen stehen vor der Aufgabe, meine Accounts, Abos, Mitgliedschaften und Versicherungen zu künden. Wo finden sie die relevanten Informationen?',
				fr: "Je suis en train de mourir et mes proches sont confrontés à la tâche d'annuler ou de résilier mes comptes, mes abonnements, mes adhésions et mes assurances. Où peuvent-ils trouver les informations pertinentes?"
			},
			name: 'contracts',
			options: [
				{
					value: 'arrangement',
					label: {
						de: 'Ich hinterlege alle Informationen an einem Ort, damit meine Angehörigen im Fall der Fälle Zugriff auf wichtige Passwörter oder Entsperrungscodes haben und beispielsweise meine Wünsche bezüglich Social Media Accounts kennen.',
						fr: "Je dépose toutes les informations au même endroit afin que mes proches aient accès aux mots de passe importants ou aux codes de déverrouillage en cas d'urgence et connaissent mes souhaits concernant les comptes de réseaux sociaux, par exemple."
					}
				},
				{
					value: 'default',
					label: {
						de: 'Ich überlasse es meinen Angehörigen, die Informationen zu suchen und zusammenzutragen.',
						fr: 'Je laisse à mes proches le soin de chercher et de rassembler les informations.'
					}
				}
			],
			value: null
		},
		{
			title: {
				de: 'Ich habe einen Unfall und liege längere Zeit im Koma. Wissen meine Angehörigen, welche Bankkonten ich wo habe?',
				fr: "J'ai un accident et je suis dans le coma depuis longtemps. Est-ce que mes proches savent où se trouvent mes comptes bancaires?"
			},
			name: 'bankaccounts',
			options: [
				{
					value: 'arrangement',
					label: {
						de: 'Ich sammle alle Kontoinformationen an einem Ort, zu welchem meine Angehörigen im Fall der Fälle Zugriff haben.',
						fr: "Je rassemble toutes les informations sur mon compte en un seul endroit, auquel mes proches ont accès en cas d'urgence."
					}
				},
				{
					value: 'default',
					label: {
						de: 'Ich überlasse es meinen Angehörigen, die Informationen zu suchen und zusammenzutragen.',
						fr: 'Je laisse à mes proches le soin de chercher et de rassembler les informations.'
					}
				}
			],
			value: null
		},
		{
			title: {
				de: 'Ich sterbe und mein Nachlass wird verteilt. Wie stelle ich sicher, dass meine Angehörigen oder Dritte so begünstigt werden, wie ich es gerne möchte?',
				fr: 'Je meurs et mes biens sont distribués. Comment faire en sorte que mes proches ou des tiers soient favorisés comme je le souhaite?'
			},
			name: 'inheritance',
			options: [
				{
					value: 'arrangement',
					label: {
						de: 'Ich halte in einem Testament fest, wer was von mir erbt, oder schliesse einen Ehe-/Erbvertrag mit meinen Angehörigen ab.',
						fr: 'Je consigne dans un testament qui hérite quoi de moi ou bien je signe un contrat de mariage ou de succession.'
					},
					sub: {
						title: {
							de: 'Meine aktuelle familiäre Situation',
							fr: 'Ma situation familiale actuelle:'
						},
						description: {
							de: 'Wenn ich ein Testament und/oder Ehevertrag habe, hängt meine frei verfügbare Quote davon ab, ob pflichtteilsgeschützte Erben vorhanden sind.',
							fr: "Si j'ai un testament et/ou un accord matrimonial, mon quota disponible dépend des héritiers qui ont droit à leur réserve héréditaire, donc obligatoire."
						},
						name: 'dependants',
						options: [
							{
								value: 'spouse',
								label: {
									de: 'Ehepartner/in oder eingetragene/r Lebenspartner/in',
									fr: 'Conjoint ou partenaire enregistré'
								}
							},
							{
								value: 'children',
								label: {
									de: 'Kinder/Enkel und deren Nachkommen',
									fr: 'Les enfants/petits-enfants et leurs descendants'
								}
							}
						],
						value: [],
						details: {
							de: `<p><strong>Kein Anrecht auf einen Plichtteil haben:</strong></p>
<ul>
  <li>Konkubinatspartner/in oder Lebensgefährte/in</li>
  <li>Weitere Verwandte wie Eltern, Geschwister, Grosseltern, Onkel, Tanten, Cousins, Cousinen und deren Nachkommen</li>
</ul>`,
							fr: `<p><strong>N'ont pas droit à une réserve héréditaire, donc à une partie obligatoire:</strong></p>
							<ul>
							  <li>Concubine ou concubin</li>
							  <li>D'autres parents tels que les parents, frères et sœurs, grands-parents, les oncles, les tantes, les cousins et leurs descendants</li>
							  </ul>`
						}
					}
				},
				{
					value: 'default',
					label: {
						de: 'Ohne Testament oder Ehe-/Erbvertrag wird mein Nachlass nach den gesetzlichen Bestimmungen verteilt.',
						fr: "Sans testament ni contrat de mariage ou d'héritage, mes biens seront répartis selon les dispositions légales."
					}
				}
			],
			value: null
		},
		{
			title: {
				de: 'Ich sterbe und meine Angehörigen haben die Aufgabe, meine Bestattung und Trauerfeier zu organisieren. Kennen sie meine Bestattungswünsche?',
				fr: "Je décède et mes proches ont la tâche d'organiser mon inhumation et mes funérailles. Connaissent-ils mes souhaits?"
			},
			name: 'funeral',
			description: {
				de: 'Ich unterstütze meine Angehörigen und halte meine Wünsche bezüglich Bestattung und Trauerfeier fest. Damit treffe ich viele Entscheidungen vor meinem Tod und gebe meinen Angehörigen die Gewissheit und das gute Gefühl, in meinem Sinn zu handeln.',
				fr: ''
			},
			options: [
				{
					value: 'arrangement',
					label: {
						de: 'Ich halte meine Wünsche fest und gebe meinen Angehörigen die Gewissheit und das gute Gefühl, in meinem Sinn zu handeln.',
						fr: "J'enregistre mes souhaits et je donne à mes proches la certitude et le bon sentiment d'agir selon mes volontés"
					}
				},
				{
					value: 'default',
					label: {
						de: 'Ich mache nichts und überlasse die Entscheidungen meinen Angehörigen.',
						fr: 'Je ne fais rien et je laisse les décisions à mes proches.'
					}
				}
			],
			value: null
		}
	],
	graphs: [
		{
			title: {
				de: 'Belastung Angehörige',
				fr: 'Fardeau pour les proches'
			},
			name: 'effort',
			value: 100,
			calculateValue(data) {
				const criteria = [
					'incapacity',
					'advancedirective',
					'organs',
					'contracts',
					'bankaccounts',
					'funeral',
					'inheritance'
				];
				const value = calculateValue(criteria, data, true);

				return value;
			},
			inverted: true
		},
		{
			title: {
				de: 'Selbstbestimmung',
				fr: 'Autodétermination'
			},
			name: 'autonomy',
			value: 0,
			calculateValue(data) {
				const criteria = [
					'incapacity',
					'advancedirective',
					'organs',
					'funeral',
					'inheritance'
				];
				const value = calculateValue(criteria, data);

				return value;
			}
		},
		{
			title: {
				de: 'Freie Quote (Erbe)',
				fr: 'Quota libre (héritage)'
			},
			name: 'quota',
			value: 0,
			calculateValue(data) {
				const { dependants, inheritance } = data;

				if (inheritance !== 'arrangement') {
					return 0;
				}

				if (!(dependants && dependants.length)) {
					return 100;
				}

				let value = 100;

				if (dependants.includes('spouse') || dependants.includes('children')) {
					value = 50;
				}

				return value;
			},
			simple: true,
			isDisabled(data) {
				return !data.inheritance;
			}
		}
	],
	summary: [
		{
			title: {
				de: 'Erstelle einen Vorsorgeauftrag',
				fr: "Crée un mandat pour cause d'inaptitude"
			},
			titlePublic: {
				de: 'Erstellen Sie einen Vorsorgeauftrag',
				fr: "Créez un mandat pour cause d'inaptitude"
			},
			ids: ['advance_care_directive'],
			isChecked: data => {
				return data.incapacity === 'arrangement';
			}
		},
		{
			title: {
				de: 'Erstelle eine Patientenverfügung',
				fr: 'Crée des directives anticipées'
			},
			titlePublic: {
				de: 'Erstellen Sie eine Patientenverfügung',
				fr: 'Créez des directives anticipées'
			},
			ids: ['advance_directive'],
			isChecked: data => {
				return data.advancedirective === 'arrangement';
			}
		},
		{
			title: {
				de: 'Beantrage einen Organspendeausweis',
				fr: "Demande une carte de donneur d'organes"
			},
			titlePublic: {
				de: 'Beantragen Sie einen Organspendeausweis',
				fr: "Demandez une carte de donneur d'organes"
			},
			ids: [],
			isChecked: data => {
				return data.organs === 'arrangement';
			}
		},
		{
			title: {
				de: 'Erstelle eine Liste deiner Accounts',
				fr: 'Crée une liste de tes comptes'
			},
			titlePublic: {
				de: 'Erstellen Sie eine Liste Ihrer Accounts',
				fr: 'Créez une liste de vos comptes'
			},
			ids: ['insurance', 'subscription', 'membership', 'access', 'socialmedia'],
			isChecked: data => {
				return data.contracts === 'arrangement';
			}
		},
		{
			title: {
				de: 'Erstelle eine Liste deiner Bankkonten',
				fr: 'Crée une liste de tes comptes bancaires'
			},
			titlePublic: {
				de: 'Erstellen Sie eine Liste Ihrer Bankkonten',
				fr: 'Créez une liste de vos comptes bancaires'
			},
			ids: ['bank'],
			isChecked: data => {
				return data.bankaccounts === 'arrangement';
			}
		},
		{
			title: {
				de: 'Regle deinen Nachlass',
				fr: 'Règle ta succession'
			},
			titlePublic: {
				de: 'Regeln Sie Ihren Nachlass',
				fr: 'Réglez votre succession'
			},
			ids: ['will'],
			isChecked: data => {
				return data.inheritance === 'arrangement';
			}
		},
		{
			title: {
				de: 'Lege deine Bestattungswünsche fest',
				fr: 'Détermine tes souhaits funéraires'
			},
			titlePublic: {
				de: 'Legen Sie Ihre Bestattungswünsche fest',
				fr: 'Déterminez vos souhaits pour les funérailles'
			},
			ids: ['funeral'],
			isChecked: data => {
				return data.funeral === 'arrangement';
			}
		}
	],
	i18n: {
		prev: {
			de: 'Zurück',
			fr: 'Retour'
		},
		next: {
			de: 'Weiter',
			fr: 'Suivant'
		},
		graphs: {
			de: 'Visualisierung',
			fr: 'Visualisation'
		},
		summary: {
			de: 'Ergebnis',
			fr: 'Résultat'
		},
		summaryIntroPublic: {
			de: [
				'Gemäss Ihren Angaben sollten Sie sich um die nachfolgenden Angelegenheiten kümmern.',
				'Über den Gratis-Account auf LegacyNotes können Sie die To-do-Liste verwalten und erste Aufgaben direkt erledigen.'
			],
			fr: ["D'après vos informations, vous devriez vous occuper des points suivants."]
		},
		summaryIntro: {
			de: ['Gemäss deinen Angaben solltest du dich um folgende Angelegenheiten kümmern:'],
			fr: ["D'après tes informations, tu devrais t’occuper des points suivants"]
		},
		signup: {
			de: 'Gratis-Account erstellen',
			fr: 'Créer un compte gratuit'
		},
		login: {
			de: 'Einloggen',
			fr: 'Se connecter'
		},
		print: {
			de: 'Checkliste drucken',
			fr: 'Imprimer la liste de contrôle'
		},
		reset: {
			de: 'Zurücksetzen und neu starten',
			fr: 'Réinitialiser et redémarrer'
		},
		showSummary: {
			de: 'Direkt zum Ergebnis',
			fr: 'Directement au résultat'
		},
		titlePrint: {
			de: 'LegacyNotes-Simulator zur Vorsorgeplanung',
			fr: 'LegacyNotes Simulateur de prévention'
		},
		start: {
			de: 'Starten',
			fr: 'Démarrer'
		},
		dashboard: {
			de: 'Zur Übersicht gehen und loslegen',
			fr: "Aller à l'aperçu et commencer"
		},
		chartLabels: {
			de: ['gering', 'hoch'],
			fr: ['bas', 'haut']
		},
		disclaimer: {
			de: `Der LegacyNotes-Simulator zur Vorsorgeplanung ist in Zusammenarbeit mit dem <a href="https://www.ost.ch/de/forschung-und-dienstleistungen/technik/wirtschaftsingenieurwesen/idee-institut-fuer-innovation-design-und-engineering" target="_blank">IDEE Institut für Innovation, Design und Engineering</a> der Fachhochschule St.Gallen entwickelt worden.`,
			fr: `Le simulateur de prévention a été développé en collaboration avec <a href="https://www.ost.ch/de/forschung-und-dienstleistungen/technik/wirtschaftsingenieurwesen/idee-institut-fuer-innovation-design-und-engineering" target="_blank">l'Institut pour l'innovation, le design et l'ingénierie IDEE</a> de la Haute école spécialisée de Saint-Gall.`
		},
		disclaimerPrint: {
			de: `Entwickelt in Zusammenarbeit mit dem <a href="https://www.ost.ch/de/forschung-und-dienstleistungen/technik/wirtschaftsingenieurwesen/idee-institut-fuer-innovation-design-und-engineering" target="_blank">IDEE Institut für Innovation, Design und Engineering</a> der Fachhochschule St.Gallen.`,
			fr: `Développé en collaboration avec <a href="https://www.ost.ch/de/forschung-und-dienstleistungen/technik/wirtschaftsingenieurwesen/idee-institut-fuer-innovation-design-und-engineering" target="_blank">l'Institut pour l'innovation, le design et l'ingénierie IDEE</a> de la Haute école spécialisée de Saint-Gall.`
		},
		copyright: {
			de: `© LegacyNotes GmbH, Rosenbergstrasse 87, 9000 St. Gallen – <a href="mailto:info@legacynotes.ch">info@legacynotes.ch</a> – <a href="https://www.legacynotes.ch">www.legacynotes.ch</a>`,
			fr: `© LegacyNotes GmbH, Rosenbergstrasse 87, 9000 Saint-Gall – <a href="mailto:info@legacynotes.ch">info@legacynotes.ch</a> – <a href="https://www.legacynotes.ch/fr">www.legacynotes.ch</a>`
		}
	},
	conversionTarget: 'AW-705946175/QZ4yCOyZmLgBEL_Ez9AC',
	domain: 'https://app.legacynotes.ch',
	localStorageKey: 'legacynotes-simulator'
};
